/* eslint-disable prefer-destructuring */
/* eslint-disable prettier/prettier */

/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)
* This project uses react-hook-form (https://react-hook-form.com), licensed under the MIT License.
Coded by www.creative-tim.com

 =========================================================
// "proxy": "https://enstools.electionsnovascotia.ca",
* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import React, { useEffect, useState, useRef } from "react";
import { useForm, useFieldArray, Controller } from "react-hook-form";
import {
  Grid,
  Container,
  Button,
  Typography,
  Card,
  Box,
  MenuItem,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  FormHelperText,
} from "@mui/material";
import MKInput from "components/MKInput";
import MKBox from "components/MKBox";
import TextField from "@mui/material/TextField";
import MKTypography from "components/MKTypography";
import MKSelect from "components/MKSelect";
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";
import routes from "routes";
import footerRoutes from "footer.routes";
import bgImage from "assets/images/bg-presentation.jpg";
import ElectoralDistricts from "constants/ElectoralDistricts";
import ElectionsYears from "constants/ElectionsYears";
import axios from "axios";
import { AddressAutocomplete } from "./AddressAutocomplete";
import Autocomplete from "@mui/material/Autocomplete";
import TopAlert from "../../TopAlert";
function MapOrderForm() {

  /*
   we are using react hook form because there is lot of conditional rendering in a form
   
   */
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    reset,
    control,
    getValues,
    setValue,

  } = useForm({
    defaultValues: {
      name: "",
      businessName: "",
      email: "",
      telephoneNumber: "",
      location: "",
      unitNumber: "",
      city: "",
      province: "",
      postalCode: "",
      billingSameAsContact: true,
      billingDetails: {
        name: "",
        telephoneNumber: "",
        location: "",
        unitNumber: "",
        city: "",
        province: "",
        postalCode: "",
      },
      mapOrder: {
        provinceMap: {
          interested: "No",
          numberOfCopies: "",
        },
        districtMap: {
          interested: "No",
          district: [],
        },
        distributionSeatsMap: {
          interested: "No",
          numberOfCopies: "",
        },
        electionsResultMap: {
          interested: "No",
          electionYears: []

        },
      },
      deliveryMethod: "",
      notes: "",
    },
  });
  const { options, loading, fetchSuggestions } = AddressAutocomplete()
  const { fields, replace } = useFieldArray({
    control,
    name: "mapOrder.districtMap.districts",
  });


  const [captchaToken, setCaptchaToken] = useState(null);
  const turnstileRef = useRef(null);
  const SITE_KEY = "0x4AAAAAAB18PIXleTTgoPDI";
  const provinces = [
    "Alberta",
    "British Columbia",
    "Manitoba",
    "New Brunswick",
    "Newfoundland and Labrador",
    "Nova Scotia",
    "Ontario",
    "Prince Edward Island",
    "Quebec",
    "Saskatchewan",
  ];

  // Watching the province map order "interested" field to conditionally render the number of copies input
  const watchProvinceMapInterested = watch("mapOrder.provinceMap.interested");
  const watchDistrictMapInterested = watch("mapOrder.districtMap.interested");
  const watchDistributionSeatsMapInterested = watch("mapOrder.distributionSeatsMap.interested");
  const watchElectionsResultMapInterested = watch("mapOrder.electionsResultMap.interested");
  const billingSameAsContact = watch("billingSameAsContact");

  const onSubmit = async (data) => {
    if (!captchaToken) {
      alert("Please complete the CAPTCHA.");
      return;
    }
    //console.log(data);
    // const hh = {
    //   ...data,
    //   "cf-turnstile-response": captchaToken,
    // };
    //console.log(hh);
    //console.log(captchaToken);
    try {
      const response = await axios.post("https://azensfunctionapp-cpf5cng4hqawhsgp.canadacentral-01.azurewebsites.net/api/maprequest", {
        ...data,
        "cf-turnstile-response": captchaToken,
      });

      if (response.data.success) {
        //console.log(response.data);
        alert("Form submitted successfully!");
        reset();
        setCaptchaToken(null);
        if (window.turnstile && turnstileRef.current) {
          window.turnstile.reset(turnstileRef.current);
        }
      } else {
        alert("CAPTCHA validation failed.");
      }
    } catch (err) {
      console.error("Error submitting form:", err);
      alert("Something went wrong while submitting the form.");
    }
  };

  useEffect(() => {
    if (window.turnstile && turnstileRef.current) {
      window.turnstile.render(turnstileRef.current, {
        sitekey: SITE_KEY,
        callback: (token) => setCaptchaToken(token),
        "error-callback": () => {
          console.error("suspisious activity noticed");

          alert("suspisious activity noticed.");
          setCaptchaToken(null);
        },

        "expired-callback": () => {
          console.warn("Turnstile token expired");
          setCaptchaToken(null);
        },
      });
    }
  }, []);
  useEffect(() => {
    if (watchProvinceMapInterested === "No") {
      setValue("mapOrder.provinceMap.numberOfCopies", "");
    }
    if (watchDistrictMapInterested === "No") {
      setValue("mapOrder.districtMap.districts", []);
    }
    if (watchDistributionSeatsMapInterested === "No") {
      setValue("mapOrder.distributionSeatsMap.numberOfCopies", "");
    }
    if (watchElectionsResultMapInterested === "No") {
      setValue("mapOrder.electionsResultMap.electionYears", []);
      setValue("mapOrder.electionsResultMap.numberOfCopies", "");
    }
  }, [
    watchProvinceMapInterested,
    watchDistrictMapInterested,
    watchDistributionSeatsMapInterested,
    watchElectionsResultMapInterested,
    setValue,
  ]);


  const handleDistrictSelectChange = (event) => {
    const selected = event.target.value;

    const currentDistricts = getValues("mapOrder.districtMap.districts");

    const updatedDistricts = selected.map((name) => {
      const existing = currentDistricts.find((d) => d.name === name);
      return existing || { name, copies: "" };
    });

    replace(updatedDistricts);
  };

  const { fields: electionYearFields, replace: replaceElectionYears } = useFieldArray({
    control,
    name: "mapOrder.electionsResultMap.electionYears",
  });


  const handleElectionYearsChange = (event) => {
    const selected = event.target.value;
    const currentYears = getValues("mapOrder.electionsResultMap.electionYears");

    const updatedYears = selected.map((year) => {
      const existing = currentYears.find((y) => y.year === year);
      return existing || { year, copies: "" };
    });

    replaceElectionYears(updatedYears);
  };

  return (
    <>
      <TopAlert/>
      <Box sx={{ paddingTop: "30px" }}>
        <DefaultNavbar routes={routes} sticky />
      </Box>

     
      <MKBox
        minHeight="55vh"
        width="100%"
        sx={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "top",
          display: "grid",
          placeItems: "center",
        }}
      >
        <Container>
          <Grid container item xs={12} lg={7} justifyContent="center" mx="auto">
            <MKTypography
              variant="h1"
              color="white"
              mt={-6}
              mb={1}
              sx={({ breakpoints, typography: { size } }) => ({
                [breakpoints.down("md")]: {
                  fontSize: size["3xl"],
                },
              })}
            >
              Elections Nova Scotia
            </MKTypography>
            <MKTypography
              variant="h3"
              color="white"
              textAlign="center"
              px={{ xs: 6, lg: 12 }}
              mt={1}
            >
              Elections That Work For You
            </MKTypography>
          </Grid>
        </Container>
      </MKBox>

      
      <Card
        sx={{
          p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <MKBox
          component="section"
          py={12}
          sx={{ backgroundColor: "#ffffff", boxShadow: "none", opacity: 1 }}
        >
          <Container>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Box mb={3}>
                  <Typography variant="h2" gutterBottom>
                    Elections Nova Scotia - Map Order Request Form
                  </Typography>
                  <Typography variant="body2" color="text.secondary" paragraph>
                    Elections Nova Scotia has a variety of map products available on our{" "}
                   website{" "}
                    and can provide hard copy maps upon request. All maps can be printed in colour
                    or black and white for the cost of <b>$26.99 (CAD)</b> plus taxes and shipping.
                  </Typography>
                  <Typography variant="body2" color="text.secondary" paragraph>
                    To request a printed map, please fill out the following information.
                  </Typography>
                </Box>
                <hr style={{ marginBottom: "15px", border: "1px solid #ccc" }} />
              </Grid>
              <Grid item xs={12}>
                <form onSubmit={handleSubmit(onSubmit)}>
                  <Grid container spacing={2}>
                    
                    <Grid item xs={12} sm={6}>
                      <Typography variant="h6" gutterBottom>
                        Full Name <span style={{ color: "#d32f2f" }}>*</span>
                      </Typography>
                      <MKInput
                        {...register("name", { required: "Name is required." })}
                        fullWidth
                        error={!!errors.name}
                        helperText={errors.name?.message}
                      />
                    </Grid>

                    
                    <Grid item xs={12} sm={6}>
                      <Typography variant="h6" gutterBottom>
                        Business Name (if applicable)
                      </Typography>
                      <MKInput
                        {...register("businessName")}
                        fullWidth
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <Typography variant="h6" gutterBottom>
                        E-mail
                      </Typography>
                      <MKInput
                        {...register("email", {
                          // required: "Email is required.",
                          pattern: {
                            value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                            message: "Invalid email format.",
                          },
                        })}
                        fullWidth
                      // error={!!errors.name}
                      // helperText={errors.name?.message}
                      />
                    </Grid>

                    {/* Telephone Number Field */}
                    <Grid item xs={12} sm={6}>
                      <Typography variant="h6" gutterBottom>
                        Telephone Number <span style={{ color: "#d32f2f" }}>*</span>
                      </Typography>
                      <MKInput
                          {...register("telephoneNumber", {
                            required: "Telephone number is required.",
                            pattern: {
                              value: /^\+?[0-9()\s.-]{10,20}$/,
                              message: "Enter a valid phone number.",
                            },
                          })}
                          fullWidth
                          error={!!errors.telephoneNumber}
                          helperText={errors.telephoneNumber?.message}
                        />
                    </Grid>
                    {/* Location Field */}
                    <Grid item xs={12} sm={6}>
                      <Typography variant="h6" gutterBottom>
                        Contact Mailing Address <span style={{ color: "#d32f2f" }}>*</span>
                      </Typography>

                      <Controller
                        name="location"
                        control={control}
                        rules={{ required: "Mailing address is required." }}
                        render={({ field }) => (
                          <Autocomplete
                            freeSolo
                            options={options}
                            loading={loading}

                            value={field.value || ""}
                            onInputChange={(_, value) => {
                              field.onChange(value);
                              fetchSuggestions(value);
                            }}
                            onChange={(_, selected) => {
                              const text =
                                typeof selected === "string"
                                  ? selected
                                  : selected?.value ?? selected?.label ?? "";
                              field.onChange(text);
                            }}
                            filterOptions={(x) => x}
                            getOptionLabel={(o) =>
                              typeof o === "string" ? o : o?.label ?? o?.value ?? ""
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                fullWidth
                                placeholder="Start typing an address…"
                                error={!!errors.location}
                                helperText={errors.location?.message}
                              />
                            )}
                            renderOption={(props, option) => (
                              <li
                                {...props}
                                key={typeof option === "object" ? option.id ?? option.label : option}
                              >
                                {typeof option === "string"
                                  ? option
                                  : option?.label ?? option?.value ?? ""}
                              </li>
                            )}
                          />
                        )}
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <Typography variant="h6" gutterBottom>
                        Unit Number
                      </Typography>
                      <MKInput
                        {...register("unitNumber")}
                        fullWidth
                        error={!!errors.unitNumber}
                        helperText={errors.unitNumber?.message}
                      />
                    </Grid>
                    {/* City Field */}
                    <Grid item xs={12} sm={4}>
                      <Typography variant="h6" gutterBottom>
                        City <span style={{ color: "#d32f2f" }}>*</span>
                      </Typography>
                      <MKInput
                        {...register("city", { required: "City is required." })}
                        fullWidth
                        error={!!errors.city}
                        helperText={errors.city?.message}
                      />
                    </Grid>

                    {/* Province Dropdown */}
                    <Grid item xs={12} sm={4}>
                      <Typography variant="h6" gutterBottom>
                        Province <span style={{ color: "#d32f2f" }}>*</span>
                      </Typography>
                      <MKSelect
                        {...register("province", { required: "Province is required." })}
                        fullWidth
                        error={!!errors.province}
                        helperText={errors.province?.message}
                        sx={{ height: "44px" }}
                        displayEmpty
                        defaultValue=""
                      >
                        <MenuItem value="" disabled>
                          Select a province
                        </MenuItem>
                        {provinces.map((province) => (
                          <MenuItem key={province} value={province}>
                            {province}
                          </MenuItem>
                        ))}
                      </MKSelect>
                    </Grid>

                    <Grid item xs={12} sm={4}>
                      <Typography variant="h6" gutterBottom>
                        Postal Code <span style={{ color: "#d32f2f" }}>*</span>
                      </Typography>
                      <MKInput
                        {...register("postalCode", {
                          required: "Postal code is required.",
                          pattern: {
                            value: /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/,
                            message: "Invalid Canadian postal code format (e.g., A1A 1A1).",
                          },
                        })}
                        fullWidth
                        error={!!errors.postalCode}
                        helperText={errors.postalCode?.message}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <label style={{ display: "flex", alignItems: "center", gap: "8px", fontSize: "1rem", fontWeight: "normal", color: "rgba(0,0,0,0.87)" }}>
                        <input
                          type="checkbox"
                          {...register("billingSameAsContact")}
                          defaultChecked
                        />
                        Billing details are same as contact details
                      </label>
                    </Grid>

                    {/* Show only when unchecked */}
                    {!billingSameAsContact && (
                      <>
                        <Grid item xs={12} sm={6}>
                          <Typography variant="h6" gutterBottom>
                            Billing Name <span style={{ color: "#d32f2f" }}>*</span>
                          </Typography>
                          <MKInput
                            {...register("billingDetails.name", { required: "Billing name is required." })}
                            fullWidth
                            error={!!errors.billingDetails?.name}
                            helperText={errors.billingDetails?.name?.message}
                          />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          <Typography variant="h6" gutterBottom>
                            Billing Telephone Number <span style={{ color: "#d32f2f" }}>*</span>
                          </Typography>
                          <MKInput
                            {...register("billingDetails.telephoneNumber", {
                              required: "Billing phone is required.",
                              pattern: {
                                value: /^[0-9]{10,15}$/,
                                message: "Invalid number (10–15 digits).",
                              },
                            })}
                            fullWidth
                            error={!!errors.billingDetails?.telephoneNumber}
                            helperText={errors.billingDetails?.telephoneNumber?.message}
                          />
                        </Grid>

                        {/* <Grid item xs={12} sm={6}>
                          <Typography variant="h6" gutterBottom>
                            Billing Address <span style={{ color: "#d32f2f" }}>*</span>
                          </Typography>
                          <MKInput
                            {...register("billingDetails.location", { required: "Billing address is required." })}
                            fullWidth
                            error={!!errors.billingDetails?.location}
                            helperText={errors.billingDetails?.location?.message}
                          />
                        </Grid> */}
                        <Grid item xs={12} sm={6}>
                          <Typography variant="h6" gutterBottom>
                            Billing Address <span style={{ color: "#d32f2f" }}>*</span>
                          </Typography>

                          <Controller
                            name="billingDetails.location"
                            control={control}
                            rules={{ required: "Billing address is required." }}
                            render={({ field }) => (
                              <Autocomplete
                                freeSolo
                                options={options}
                                loading={loading}
                                value={field.value || ""}
                                onInputChange={(_, value) => {
                                  field.onChange(value);
                                  fetchSuggestions(value);
                                }}
                                onChange={(_, selected) => {
                                  const text =
                                    typeof selected === "string"
                                      ? selected
                                      : selected?.value ?? selected?.label ?? "";
                                  field.onChange(text);
                                }}
                                filterOptions={(x) => x}
                                getOptionLabel={(o) =>
                                  typeof o === "string" ? o : o?.label ?? o?.value ?? ""
                                }
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    fullWidth
                                    placeholder="Start typing an address…"
                                    error={!!errors.billingDetails?.location}
                                    helperText={errors.billingDetails?.location?.message}
                                  />
                                )}
                                renderOption={(props, option) => (
                                  <li
                                    {...props}
                                    key={typeof option === "object" ? option.id ?? option.label : option}
                                  >
                                    {typeof option === "string"
                                      ? option
                                      : option?.label ?? option?.value ?? ""}
                                  </li>
                                )}
                              />
                            )}
                          />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          <Typography variant="h6" gutterBottom>
                            Unit Number
                          </Typography>
                          <MKInput
                            {...register("billingDetails.unitNumber")}
                            fullWidth
                            error={!!errors.billingDetails?.unitNumber}
                            helperText={errors.billingDetails?.unitNumber?.message}
                          />
                        </Grid>

                        <Grid item xs={12} sm={4}>
                          <Typography variant="h6" gutterBottom>
                            City <span style={{ color: "#d32f2f" }}>*</span>
                          </Typography>
                          <MKInput
                            {...register("billingDetails.city", { required: "City is required." })}
                            fullWidth
                            error={!!errors.billingDetails?.city}
                            helperText={errors.billingDetails?.city?.message}
                          />
                        </Grid>

                        <Grid item xs={12} sm={4}>
                          <Typography variant="h6" gutterBottom>
                            Province <span style={{ color: "#d32f2f" }}>*</span>
                          </Typography>
                          <MKSelect
                            {...register("billingDetails.province", { required: "Province is required." })}
                            fullWidth
                            error={!!errors.billingDetails?.province}
                            helperText={errors.billingDetails?.province?.message}
                            sx={{ height: "44px" }}
                            displayEmpty
                            defaultValue=""
                          >
                            <MenuItem value="" disabled>Select a province</MenuItem>
                            {provinces.map((province) => (
                              <MenuItem key={province} value={province}>{province}</MenuItem>
                            ))}
                          </MKSelect>
                        </Grid>

                        <Grid item xs={12} sm={4}>
                          <Typography variant="h6" gutterBottom>
                            Postal Code <span style={{ color: "#d32f2f" }}>*</span>
                          </Typography>
                          <MKInput
                            {...register("billingDetails.postalCode", {
                              required: "Postal code is required.",
                              pattern: {
                                value: /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/,
                                message: "Invalid Canadian postal code format (e.g., A1A 1A1).",
                              },
                            })}
                            fullWidth
                            error={!!errors.billingDetails?.postalCode}
                            helperText={errors.billingDetails?.postalCode?.message}
                          />
                        </Grid>
                      </>
                    )}


                    {/* Provincial Map Order */}
                    <Grid item xs={12}>
                      <Typography variant="h6" gutterBottom>
                        Provincial Electoral Districts of Nova Scotia Map{" "}
                        <span style={{ color: "#d32f2f" }}>*</span>
                      </Typography>

                      <Typography variant="body2" color="text.secondary" gutterBottom>
                        {`Would you like to order a 36" x 44" provincial map of electoral districts?`}
                      </Typography>
                      <MKSelect
                        {...register("mapOrder.provinceMap.interested", {
                          required: "Please select an option.",
                        })}
                        fullWidth
                        defaultValue="No"
                        error={!!errors.mapOrder?.provinceMap?.interested}
                        helperText={errors.mapOrder?.provinceMap?.interested?.message}
                        sx={{ height: "44px" }}
                      >
                        <MenuItem value="Yes">Yes</MenuItem>
                        <MenuItem value="No">No</MenuItem>
                      </MKSelect>
                    </Grid>

                    {/* Number of Copies for Provincial Map */}
                    {watchProvinceMapInterested === "Yes" && (
                      <Grid item xs={12}>
                        <Typography variant="body2" color="text.secondary" gutterBottom>
                          Number of copies you wish to order of the Provincial Electoral Districts
                          map <span style={{ color: "#d32f2f" }}>*</span>
                        </Typography>
                        <MKInput
                          {...register("mapOrder.provinceMap.numberOfCopies", {
                            required: "Please enter the number of copies.",
                            min: {
                              value: 1,
                              message: "Number of copies must be at least 1 & must be a number.",
                            },
                          })}
                          type="number"
                          fullWidth
                          error={!!errors.mapOrder?.provinceMap?.numberOfCopies}
                          helperText={errors.mapOrder?.provinceMap?.numberOfCopies?.message}
                        />
                      </Grid>
                    )}

                    {/* District Map Order */}
                    <Grid item xs={12}>
                      <Typography variant="h6" gutterBottom>
                        Electoral District Map <span style={{ color: "#d32f2f" }}>*</span>
                      </Typography>

                      <Typography variant="body2" color="text.secondary" gutterBottom>
                        {`Would you like to order a 36" x 44" map of one of the electoral districts of Nova Scotia?`}
                      </Typography>

                      <MKSelect
                        {...register("mapOrder.districtMap.interested", {
                          required: "Please select an option.",
                        })}
                        fullWidth
                        defaultValue="No"
                        error={!!errors.mapOrder?.districtMap?.interested}
                        helperText={errors.mapOrder?.districtMap?.interested?.message}
                        sx={{ height: "44px" }}
                      >
                        <MenuItem value="Yes">Yes</MenuItem>
                        <MenuItem value="No">No</MenuItem>
                      </MKSelect>
                    </Grid>
                    {watchDistrictMapInterested === "Yes" && (
                      <>
                        <Grid item xs={12}>
                          <Typography variant="body2" gutterBottom>
                            Please select electoral district(s){" "}
                            <span style={{ color: "#d32f2f" }}>*</span>
                          </Typography>
                          <MKSelect
                            multiple
                            fullWidth
                            sx={{ height: "44px" }}
                            value={fields.map((d) => d.name)}
                            onChange={handleDistrictSelectChange}

                            error={!!errors.mapOrder?.districtMap?.district}
                            helperText={errors.mapOrder?.districtMap?.district?.message}
                            displayEmpty
                            defaultValue=""
                          >
                            <MenuItem value="" disabled>
                              Select districts
                            </MenuItem>
                            {Object.keys(ElectoralDistricts).map((district) => (
                              <MenuItem key={district} value={ElectoralDistricts[district]}>
                                {ElectoralDistricts[district]}
                              </MenuItem>
                            ))}
                          </MKSelect>
                        </Grid>

                        {/* Render input for copies per district */}
                        {fields.map((field, index) => (
                          <Grid item xs={12} key={field.id}>
                            <Typography variant="body2" gutterBottom>
                              Number of copies for <strong>{field.name}</strong>
                            </Typography>
                            <MKInput
                              type="number"
                              fullWidth
                              {...register(`mapOrder.districtMap.districts.${index}.copies`, {
                                required: "Required",
                                min: {
                                  value: 1,
                                  message: "Must be at least 1",
                                },
                              })}
                              error={!!errors.mapOrder?.districtMap?.districts?.[index]?.copies}
                              helperText={
                                errors.mapOrder?.districtMap?.districts?.[index]?.copies?.message
                              }
                            />
                          </Grid>
                        ))}
                      </>
                    )}

                    

                    {/* Distribution of seats map */}
                    <Grid item xs={12}>
                      <Typography variant="h6" gutterBottom>
                        Distibution of seats Map <span style={{ color: "#d32f2f" }}>*</span>
                      </Typography>

                      <Typography variant="body2" color="text.secondary" gutterBottom>
                        {
                          "Would you like to order a 36 x 44 copy of the current Distibution of Seats by Registered Political Party Map?"
                        }
                      </Typography>

                      <MKSelect
                        defaultValue="No"
                        {...register("mapOrder.distributionSeatsMap.interested", {
                          required: "Please select an option.",
                        })}
                        fullWidth
                        sx={{ height: "44px" }}
                        error={!!errors.mapOrder?.distributionSeatsMap?.interested}
                        helperText={errors.mapOrder?.distributionSeatsMap?.interested?.message}
                      >
                        <MenuItem value="Yes">Yes</MenuItem>
                        <MenuItem value="No">No</MenuItem>
                      </MKSelect>
                    </Grid>

                    {/* Number of Copies for Provincial Map */}
                    {watchDistributionSeatsMapInterested === "Yes" && (
                      <Grid item xs={12}>
                        <Typography variant="body2" color="text-secondary" gutterBottom>
                          Number of copies you wish to order of the current Distribution of Seats
                          Map <span style={{ color: "#d32f2f" }}>*</span>
                        </Typography>

                        <MKInput
                          {...register("mapOrder.distributionSeatsMap.numberOfCopies", {
                            required: "Please enter the number of copies.",
                            min: {
                              value: 1,
                              message: "Number of copies must be at least 1 & must be a number.",
                            },
                          })}
                          type="number"
                          fullWidth
                          error={!!errors.mapOrder?.distributionSeatsMap?.numberOfCopies}
                          helperText={
                            errors.mapOrder?.distributionSeatsMap?.numberOfCopies?.message
                          }
                        />
                      </Grid>
                    )}

                    {/* Elections result Map Order */}
                    <Grid item xs={12}>
                      <Typography variant="h6" gutterBottom>
                        Election result map <span style={{ color: "#d32f2f" }}>*</span>
                      </Typography>

                      <Typography
                        variant="body2"
                        sx={{
                          alignItems: "flex-start",
                          "& .MuiFormControlLabel-label": {
                            fontWeight: "normal",
                            fontSize: "0.85rem",
                          },
                        }}
                        color="text.secondary"
                        gutterBottom
                      >
                        {`Would you like to order a 36" x 44" election result map`}
                      </Typography>

                      <MKSelect
                        {...register("mapOrder.electionsResultMap.interested", {
                          required: "Please select an option.",
                        })}
                        fullWidth
                        defaultValue="No"
                        sx={{ height: "44px" }}
                        error={!!errors.mapOrder?.electionsResultMap?.interested}
                        helperText={errors.mapOrder?.electionsResultMap?.interested?.message}
                      >
                        <MenuItem value="Yes">Yes</MenuItem>
                        <MenuItem value="No">No</MenuItem>
                      </MKSelect>
                    </Grid>
                    {/* Election Years Multi-Select */}
                    {watchElectionsResultMapInterested === "Yes" && (
                      <>
                        <Grid item xs={12}>
                          <Typography variant="body2" gutterBottom>
                            Please select election year(s) <span style={{ color: "#d32f2f" }}>*</span>
                          </Typography>
                          <MKSelect
                            multiple
                            fullWidth
                            sx={{ height: "44px" }}
                            value={electionYearFields.map((y) => y.year)}
                            onChange={handleElectionYearsChange}
                            error={!!errors.mapOrder?.electionsResultMap?.electionYears}
                            helperText={errors.mapOrder?.electionsResultMap?.electionYears?.message}
                          >
                            {Object.keys(ElectionsYears).map((key) => (
                              <MenuItem key={key} value={ElectionsYears[key]}>
                                {ElectionsYears[key]}
                              </MenuItem>
                            ))}
                          </MKSelect>
                        </Grid>

                        {/* Render input for copies per election year */}
                        {electionYearFields.map((field, index) => (
                          <Grid item xs={12} key={field.id}>
                            <Typography variant="body2" gutterBottom>
                              Number of copies for <strong>{field.year}</strong>
                            </Typography>
                            <MKInput
                              type="number"
                              fullWidth
                              {...register(`mapOrder.electionsResultMap.electionYears.${index}.copies`, {
                                required: "Required",
                                min: { value: 1, message: "Must be at least 1" },
                              })}
                              error={!!errors.mapOrder?.electionsResultMap?.electionYears?.[index]?.copies}
                              helperText={errors.mapOrder?.electionsResultMap?.electionYears?.[index]?.copies?.message}
                            />
                          </Grid>
                        ))}
                      </>
                    )}

                    
                    <Grid item xs={12}>
                      <Typography variant="h6" gutterBottom>
                        Choose your method of delivery <span style={{ color: "#d32f2f" }}>*</span>
                      </Typography>
                      <FormControl component="fieldset" error={!!errors.deliveryMethod}>
                        
                        <RadioGroup>
                          <FormControlLabel
                            value="pickup"
                            control={
                              <Radio
                                {...register("deliveryMethod", {
                                  required: "Please select a delivery method.",
                                })}
                              />
                            }
                            label="Pick-up at Elections Nova Scotia head office: 505-202 Brownlow Avenue Dartmouth, NS B3J 1TS"
                          />
                          <FormControlLabel
                            value="shipment"
                            control={
                              <Radio
                                {...register("deliveryMethod", {
                                  required: "Please select a delivery method.",
                                })}
                              />
                            }
                            label="Shipment by courier within Canada. Courier charges based on shipping address"
                          />
                        </RadioGroup>
                        {errors.deliveryMethod && (
                          <FormHelperText>{errors.deliveryMethod.message}</FormHelperText>
                        )}
                      </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="h6" gutterBottom>
                        Additional Notes (Optional)
                      </Typography>
                      <MKInput
                        {...register("notes", {
                          maxLength: {
                            value: 1000,
                            message: "Notes cannot exceed 1000 characters.",
                          },
                        })}
                        fullWidth
                        multiline
                        rows={4}
                        placeholder="Enter any additional details or requests..."
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="h6" gutterBottom>
                        Payment Methods
                      </Typography>
                      <Typography variant="body2" color="text.secondary" paragraph>
                        Please note that we have limited payment methods, and can only accept
                        payment by cheque or cash (if paying cash, we require you to bring the exact
                        value indicated on your invoice which will be sent to you). For any question{" "}
                        <a href="/contact-us">
                          <u>Contact-us</u>
                        </a>
                      </Typography>
                    </Grid>
                    
                    <Grid item xs={12}>
                      <Button
                        type="submit"
                        variant="contained"
                        sx={{
                          backgroundColor: "#1976d2",
                          color: "#fff",
                          "&:hover": {
                            backgroundColor: "#1565c0",
                          },
                        }}
                      >
                        Submit Request
                      </Button>
                    </Grid>
                  </Grid>
                </form>
                <Box mt={2}>
                  <div ref={turnstileRef} className="cf-turnstile" />
                </Box>
              </Grid>
            </Grid>
          </Container>
        </MKBox>
      </Card>

      {/* Footer Section */}
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default MapOrderForm;
